var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:[_vm.isLast ? "last" : ""],on:{"click":_vm.onClick}},[(_vm.isChecked)?_c('img',{staticClass:"check",attrs:{"src":require("../../assets/image/ic_select.png")}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"caption",class:[_vm.isChecked ? "checked" : ""]},[_vm._v(_vm._s(_vm.item))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51a85be6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/MFSelectItem.vue
// module id = null
// module chunks = 